// stores 
import * as ProtocolConsumptionStore from '../../../redux/middleware/ProtocolConsumptionMiddleware';
import * as ProtocolStore from '../../../redux/middleware/MedicalProtocolMiddleware';

// state
import { AppState } from '../../../redux/reducers';
import { ProtocolConsumption } from '../../../models/Entities/Protocols/ProtocolConsumption';
import { Protocol } from '../../../models/Entities/Protocols/Protocol';
import { Practitioner } from '../../../models/Entities/Practitioners/Practitioner';
import { ProtocolConsumptionVisit } from '../../../models/Entities/Protocols/ProtocolConsumptionVisit';

//#region Props

interface IProps {
    ProtocolId: number;
    ProtocolConsumptionId: string;
}

interface ConnectedProps {
    // loading
    isLoading: boolean;
    successLoading: boolean;
    failLoading: boolean;
    errorOnLoading: string | null;

    // changing amount
    isChangingAmount: boolean;
    successChangingAmount: boolean;
    failChangingAmount: boolean;
    errorOnChangingAmount: string | null;
    
    Protocol: Protocol | null;
    Consumption: ProtocolConsumption | null;
}

interface MedicalServicesDispatchProps {
    GetProtocolConsumptionById: typeof ProtocolConsumptionStore.ActionCreators.GetProtocolConsumptionById;
    ChangeAmount: typeof ProtocolConsumptionStore.ActionCreators.ChangeAmount;
    GetMedicalProtocolById: typeof ProtocolStore.actionCreators.GetMedicalProtocolById;
}

export type Props = IProps & ConnectedProps & MedicalServicesDispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {

    const auxProtocol: Protocol | null = state.MedicalProtocols?.list?.find((protocol: Protocol) => protocol.id === ownProps.ProtocolId) || null;

const auxConsumption: ProtocolConsumption | null =
    // flat list (includes items stored by GetProtocolConsumptionById)
    auxProtocol?.consumptions?.find(
        (consumption: ProtocolConsumption) => consumption.id === ownProps.ProtocolConsumptionId
    ) ??
    // visit sub-consumptions
    auxProtocol?.ConsumptionVisits?.flatMap(
        (visit: ProtocolConsumptionVisit) => visit.consumptions ?? []
    ).find(
        (consumption: ProtocolConsumption) => consumption.id === ownProps.ProtocolConsumptionId
    ) ??
    // child consumptions embedded in parent items (before full fetch completes)
    auxProtocol?.consumptions?.flatMap(
        (consumption: ProtocolConsumption) => consumption.childConsumption ?? []
    ).find(
        (consumption: ProtocolConsumption) => consumption.id === ownProps.ProtocolConsumptionId
    ) ?? null;

return {
    isLoading: state.MedicalProtocols?.isLoadingOneConsumption || false,
    successLoading: state.MedicalProtocols?.LoadingOneConsumptionSuccess || undefined,
    failLoading: state.MedicalProtocols?.FailGettingOneConsumption || null,
    errorOnLoading: state.MedicalProtocols?.ErrorGettingOneConsumption || null,

    isChangingAmount: auxConsumption?.isAmountChanging || false,
    successChangingAmount: auxConsumption?.amountChanged || undefined,
    failChangingAmount: auxConsumption?.failonAmountChange || null,
    errorOnChangingAmount: auxConsumption?.ErrorOnAmountChange || null,

    Protocol: auxProtocol,
    Consumption: auxConsumption
}
};

export const mapDispatchToProps = {
    ...ProtocolConsumptionStore.ActionCreators,
    ...ProtocolStore.actionCreators
};

export const GetStatusDescription = (status: number) => {

    switch (status) {
        case 0:
            return 'Pendiente de liquidación';
        case 1:
            return 'Con saldo pendiente';
        case 2:
            return 'Pagado';
        case 3:
            return 'Liquidado';
        case 4:
            return 'Rechazado';
        case 5:
            return 'Ignorado';
        case 6: 
            return 'Para liquidar';
        case 7: 
            return 'Facturado';
        default:
            return 'Unknown';
    }
};

// get person by identifier
const GetPersonByIdentifier = (persons: Practitioner[], identifier: string): Practitioner | undefined => {
  return persons.find((person: Practitioner) => person.userId === identifier);
}